import React from 'react';
import ReactJson from 'react-json-view';
import styled from 'styled-components';

import { LogItem } from '../../helpers/logger';

const Container = styled.div`
  position: relative;
  padding-top: 20px;
  border-bottom: solid 1px #00000078;
  &:last-child {
    border-bottom: none;
  }
`;
const TimeStamp = styled.div`
  color: #808080;
  position: absolute;
  left: 0;
  top: 0;
`;

const FileName = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  color: #8080807a;
`;

interface IDebugItem {
  items: LogItem[];
}

const fill = (num: number, slice = -2) => (`0` + num).slice(slice);

const getFormat = (timeStamp) => {
  if (!timeStamp) {
    return '';
  }
  const d = new Date(timeStamp);
  return `${fill(d.getHours())}:${fill(d.getMinutes())}:${fill(
    d.getSeconds()
  )}:${fill(d.getMilliseconds(), -3)}`;
};

const DebugItem: React.FC<IDebugItem> = (props: IDebugItem) => {
  const { items } = props;
  return (
    <>
      {items.map((item, index) => {
        return (
          <Container key={index}>
            {item?.message}
            {item?.payload && (
              <ReactJson
                src={item.payload}
                collapseStringsAfterLength={40}
                indentWidth={2}
                collapsed
                name={false}
              />
            )}
            <TimeStamp>{getFormat(item?.timeStamp)}</TimeStamp>
            <FileName>{item?.fileName}</FileName>
          </Container>
        );
      })}
    </>
  );
};

export default DebugItem;
